/** @fileoverview PrimeReact-style `Dialog` (`header`, `onHide`) over AppModal's shared portal, focus and scroll lifecycle, kept so screens moved off PrimeReact need no rewrite. Workspaces retain ownership of visibility and business actions. */
import React from 'react';
import AppModal from './AppModal';
export function Dialog({ header, visible, onHide, footer, children, style, contentStyle, className, closable = true, dismissableMask, closeOnEscape = true }) {
  return <AppModal visible={visible} title={header} onClose={onHide} footer={footer} width={style?.width}
    style={style} contentStyle={contentStyle} className={className} closable={closable}
    dismissableMask={dismissableMask} closeOnEscape={closeOnEscape}>{children}</AppModal>;
}
export default Dialog;
